import React, { useState } from 'react';
import DecisionTree from './components/DecisionTree';
import './App.css';

function App() {
  return (
    <div className="App">
      <DecisionTree />
    </div>
  );
}

export default App;
